import React from "react";

/**
 * Contract Holder Program Performance "Delivery Rating" More Info Component
 * @returns {Element}
 * @constructor
 */
export default function Delivery() {
  return (<tr className="extra-info">
    <td colSpan={6}>
      <div>
        <h6 className="bold">Delivery Rating</h6>
        <p>The Delivery rating refers to the contract holder's ability to meet the expected delivery date as agreed upon
          by both the contract holder
          and ordering agency during the quoting period of a SEWP request. The rating will be calculated based on the
          percentage of late deliveries
          and missed deliveries as well as factor in the average delay in delivery during the past six months for each
          contract holder.</p>
        <p>The average delay will be considered and contract holders may receive up to 3 additional strikes:</p>
        <ul>
          <li>30 - 45 Days: 1 strike</li>
          <li>45 - 60 Days: 2 strikes</li>
          <li> &nbsp; &#62; 60 Days 3: Strikes</li>
        </ul>

        <p><em>Note: Unlike other Program Performance ratings, Delivery will be rated on a monthly basis</em></p>

        <ul
          id="delivery-info-list"
        >
          <li><strong>Percentage: &nbsp; Rating</strong></li>
          <li><strong>0-10%:</strong> &nbsp; &nbsp; <span
            className="excellent">No Downgrade or Strike (Excellent) </span>
          </li>
          <li><strong>11-15%:</strong> &nbsp; 1 Strike</li>
          <li><strong>16-25%:</strong> &nbsp; <span className="very-good">1 Downgrade (Very Good) </span>
          </li>
          <li><strong>26-35%:</strong> &nbsp; 1 Downgrade + 1 Strike</li>
          <li><strong>36-45%:</strong> &nbsp; <span className="good">2 Downgrade (Good) </span></li>
          <li><strong>46-55%:</strong> &nbsp; 2 Downgrade + 1 Strike</li>
          <li><strong>56-65%:</strong> &nbsp; <span className="fair">3 Downgrade (Fair) </span></li>
          <li><strong>66-75%:</strong> &nbsp; 3 Downgrade + 1 Strike</li>
          <li><strong>&#62; 75%:</strong> &nbsp; &nbsp; &nbsp;<span className="poor">4 Downgrade (Poor) </span>
          </li>
          <li><strong>&#60; 5 Orders:</strong> &nbsp;Insufficient Data (Neutral Rating)</li>
        </ul>
      </div>
    </td>
  </tr>);
}